import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import styled from 'styled-components'

import theme from 'theme'

export type ErrorContainerProps = {
  message: string
  onReloadHandler?: () => void
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    height: calc(100vh - 168px);
  }
`

const ReloadContainer = styled.div`
  height: 60px;
  width: 60px;
  padding: 0;
  margin-bottom: 10px;
  background-color: ${theme.colors.ivory};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

const Message = styled.p`
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  margin-bottom: 6px;
  margin-top: 0;
  color: ${theme.colors.slate};
  text-align: center;
`

const SubMessage = styled.p`
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  margin: 0;
  color: ${theme.colors.slate};
  opacity: 0.6;
`

export const ErrorContainer = (props: ErrorContainerProps) => (
  <Wrapper>
    <ReloadContainer onClick={props.onReloadHandler ?? (() => window.location.reload())}>
      <AcornsIcon icon={AcornsIcon.Icon.Reload} width={24} height={24} />
    </ReloadContainer>
    <Message>{props.message}</Message>
    <SubMessage>Tap to retry</SubMessage>
  </Wrapper>
)
